/**
 * ProductsShell — domain frame for Products & Features.
 */

import { useAuth } from '@/contexts/AuthContext';
import { DomainShell } from '@/components/DomainShell';

const REQ = ['SuperAdmin', 'Admin', 'RetailAdmin'] as const;

const SUBNAV = [
  { slug: 'products', label: 'Products', requiredRoles: REQ },
  { slug: 'features', label: 'Features', requiredRoles: REQ },
  { slug: 'card-types', label: 'Card Types', requiredRoles: REQ },
  { slug: 'product-features', label: 'Product / Feature Matrix', requiredRoles: REQ },
  { slug: 'product-customer-types', label: 'Customer Types', requiredRoles: REQ },
  { slug: 'product-service-availability', label: 'Service Availability', requiredRoles: REQ },
  { slug: 'product-funding-methods', label: 'Funding Methods', requiredRoles: REQ },
  { slug: 'product-summary-chips', label: 'Summary Chips', requiredRoles: REQ },
  { slug: 'deposit-rates', label: 'Deposit Rates', requiredRoles: REQ },
];

export function ProductsShell(): JSX.Element {
  const { user } = useAuth();
  return (
    <DomainShell
      title="Products & Features"
      description="The full catalog of things a customer can open, plus the features and cards tied to each. The product/feature matrix drives the AddToCartModal eligibility filter."
      basePath="/retail/products"
      items={SUBNAV.map((s) => ({
        slug: s.slug,
        label: s.label,
        requiredRoles: s.requiredRoles,
      }))}
      userRoles={user?.roles ?? []}
    />
  );
}
